import { useState, useEffect, useCallback } from 'react';
import { subDays, startOfDay, endOfDay } from 'date-fns';
import api from '../api';
import { ptsFor } from '../utils/points';

// Powers the thin scoreboard strip on the Chores tab: last-7-days points per
// person (same "points" unit used everywhere — the app doesn't otherwise
// store a "points" field).
export default function useWeeklyScoreboardStrip(token, hasHousehold) {
  const [logs, setLogs] = useState([]);

  const refetch = useCallback(async () => {
    if (!token || !hasHousehold) return;
    try {
      const from = startOfDay(subDays(new Date(), 7));
      const to = endOfDay(new Date());
      const res = await api.get(`/chores/logs/analytics?from=${from.toISOString()}&to=${to.toISOString()}`);
      setLogs(res.data);
    } catch (err) {
      console.error('Error fetching weekly scoreboard:', err);
    }
  }, [token, hasHousehold]);

  useEffect(() => { refetch(); }, [refetch]);

  const byPerson = new Map();
  logs.forEach(log => {
    const points = ptsFor(log.actualMinutes, log.actualDifficulty);
    log.user.forEach(u => {
      if (!byPerson.has(u.id)) byPerson.set(u.id, { ...u, points: 0 });
      byPerson.get(u.id).points += points;
    });
  });

  const standings = Array.from(byPerson.values()).sort((a, b) => b.points - a.points);
  const total = standings.reduce((s, p) => s + p.points, 0);

  return { standings, total, refetch };
}
